<template>
  <custom-dialog
    :width="$store.state.isMobile ? '80%' : '600px'"
    ref="noAccess"
  >
    <div class="container flex flex-direction align-center" style="">
      <div class="title" v-if="!tips2">{{ tips }}</div>
      <div class="title" style="width: 100%" v-if="tips2" v-html="tips2"></div>
      <div class="btn-box">
        <div
          class="btn flex justify-center align-center cs"
          @click="didClick_btn"
        >
          {{ btn }}
        </div>
      </div>
    </div>
  </custom-dialog>
</template>

<script>
export default {
  name: "NoAccess",
  props: {
    tips: {
      type: String,
      default: "很抱歉，本论坛仅面向定邀受众，请选择其他直播进行观看",
    },
    btn: {
      type: String,
      default: "好的",
    },
    tips2: {
      type: String,
      default: "",
    },
  },
  components: {
    CustomDialog: () => import("../CustomDialog"),
  },
  data() {
    return {};
  },
  methods: {
    showDialog() {
      this.$refs.noAccess.showDialog();
    },
    hideDialog() {
      this.$refs.noAccess.hideDialog();
    },
    didClick_btn() {
      this.$emit("closedNoAccess");
      this.hideDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 214px;
  font-family: Microsoft YaHei-Light;
  font-weight: 400;
  padding-left: 18px;
  padding-right: 18px;
  position: relative;
  .close-dialog-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
  }
  .title {
    padding-top: 63px;
    font-size: 18px;
    color: #333333;
    margin-bottom: 10px;
    font-family: Microsoft YaHei-Light;
    font-weight: 400;
    padding-bottom: 30px;
    text-align: center;
  }

  .btn {
    width: 170px;
    height: 40px;
    background: #b4251e;
    opacity: 1;
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 20px;
  }
}

@media (min-width: 992px) {
}

@media (max-width: 992px) {
  .container {
    height: 255px;
    font-family: Microsoft YaHei-Light;
    font-weight: 400;
    margin: 0 auto;
    .title {
      font-size: 28px;
      color: #333333;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      text-align: center;
    }

    .btn {
      width: 255px;
      height: 60px;
      background: #b4251e;
      font-size: 24px;
      color: #ffffff;
    }
  }
}
</style>
